<template>
  <div class="app-container">
    <list ref="list"> </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/basedata/basedoc/billtype/list";
import editDialog from "@/components/basedata/basedoc/billtype/editDialog";

export default {
  name: "billtype",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  methods: {},
};
</script>